import React from 'react';

import { Box, Typography } from '@material-ui/core';

import { useEventTheme } from '../../context/EventThemeContext';

type PageTopProps = {
  pageTitle?: string;
  actions?: React.ReactNode;
};

export const PageTop = (props: PageTopProps) => {
  const { pageTitle, actions } = props;
  const { isCosmicTheme: cosmic } = useEventTheme();
  return (
    <Box display="flex" mb={2.4}>
      {pageTitle && (
        <Typography
          variant="h4"
          component="h2"
          style={{ color: cosmic ? '#ffffff' : undefined }}
        >
          {pageTitle}
        </Typography>
      )}

      {actions && <Box marginLeft="auto">{actions}</Box>}
    </Box>
  );
};
